import styled from 'styled-components';

export const AnswerContainer = styled.div`
    width: 100%;
    padding-top: 1em;
    border-top: 1px solid #d8d8d8;
`;